import { useSWR } from '$hooks';
import { API_URL } from '$lib/helpers';
import { http } from '$lib/http';
import {
    IEnrichedProduct,
    IGiftshopProduct,
    IGiftShopStandardMessage,
    IGiftShopStoreList,
    IOrderIAddress,
    IShippingPickup,
    ISpecialGiftShopDeliveryDatesAvailable,
} from '$models';

const giftShopUrl = `${API_URL}/scom/api/giftshop`;

export const useGiftShop = () => {
    const { data: occasions } = useSWR<IGiftshopProduct[]>(`${API_URL}/scom/api/giftShop/getGiftshopOccasions`);

    const { data: giftWrapOccasions } = useSWR<IGiftshopProduct[]>(`${API_URL}/scom/api/orders/giftWrapOccasions`);

    const { data: cards } = useSWR<IEnrichedProduct[]>(`${API_URL}/scom/api/giftShop/getCardItems`);

    const { data: messages } = useSWR<IGiftShopStandardMessage[]>(`${API_URL}/scom/api/giftShop/getStandardmessages`);

    const getPickupShippingMethod = async (): Promise<IShippingPickup | undefined> => {
        const reponse = await http(`${giftShopUrl}/getPickupShippingMethod`);
        if (!reponse.ok) {
            return undefined;
        }
        const shippingType = await reponse.json();
        return shippingType;
    };

    const getSpecialDeliveryDatesAvailable = async (
        zipcode: string
    ): Promise<ISpecialGiftShopDeliveryDatesAvailable | null> => {
        const reponse = await http(`${giftShopUrl}/specialDeliveryDatesAvailable?zipcode=${zipcode}`);
        if (!reponse.ok) {
            return null;
        }
        const availability = await reponse.json();
        return availability;
    };

    const getAvailableShops = async (zipcode: string, deliveryDate: Date): Promise<IGiftShopStoreList | undefined> => {
        const reponse = await http(
            `${giftShopUrl}/getAvailableShops?zipcode=${zipcode}&deliveryDate=${deliveryDate.toISOString()}`
        );
        if (!reponse.ok) {
            return undefined;
        }
        const shopData = await reponse.json();
        return shopData;
    };

    const getAvailableCollectShops = async (
        zipcode: string,
        deliveryDate: Date,
        limit = 3
    ): Promise<IOrderIAddress[] | undefined> => {
        const reponse = await http(
            `${giftShopUrl}/getAvailableGiftshopCollectShops?zipcode=${zipcode}&pickupDate=${deliveryDate.toISOString()}&limit=${limit}`
        );
        if (!reponse.ok) {
            return undefined;
        }
        const shopData = await reponse.json();
        return shopData;
    };

    return {
        occasions,
        giftWrapOccasions,
        cards,
        messages,
        getPickupShippingMethod,
        getSpecialDeliveryDatesAvailable,
        getAvailableShops,
        getAvailableCollectShops,
    };
};
